import {decorateDateString} from "../../utils/decorateDateString";
import {getContentsOfURI} from "../../utils/getContentsOfURI";
import {addImpression} from "../../utils/addImpression";
import {hostnameFromURL} from "../../utils/hostnameFromURL";
import {populateGeneralData} from "../../utils/populateGeneralData";

export function populateLinkBox(entry, container, timelineElement) {
    if (container[0]?.classList.contains("already-loaded")) {
        return;
    } else {
        container?.[0]?.classList.add("already-loaded");
    }
    var clonedBox = $(".link_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("link_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.find(".js-headline").prepend(entry.description);
    clonedBox.find("input[type=\"hidden\"][name=\"post_id\"]").val(entry.id);
    clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
    populateGeneralData(clonedBox,entry);
    let mainImageFound=false;
   /* if(entry.image){
        clonedBox.find(".js-timeline-image").html(
            `<img src="${entry.image}" />`
        );
        mainImageFound=true
    }*/
    clonedBox.find(".js-spinner").hide();
    let commentContent=entry.content;
    commentContent="<h3>"+entry.description+"</h3><br/>"+commentContent;


    clonedBox.find(".js-author-comment").html(commentContent);
    if (entry.link !== "") {
        clonedBox.find(".js-link-preview").attr("href", entry.link);
        var baseLink = hostnameFromURL(entry.link);
        clonedBox.find(".js-link-preview").text(baseLink);
        clonedBox.find(".js-link-preview-button").attr("href", entry.link);
        getContentsOfURI(entry.link, entry.id, entry.type, timelineElement);
    }
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}